// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610151040/js/" + chunkId + "." + {"44":"b202c1f4","225":"3b954087","481":"9be005c8","486":"91f447bf","770":"eddeb38a"}[chunkId] + ".0.3729285735993797.chunk.js";
};